
import Vue from "vue";

interface Data {
  scrollY: number;
  previousTheme: string | null;
}

interface Computed {
  help: string;
}

interface Methods {
  scroll(): void;
}

export default Vue.extend<Data, Methods, Computed, unknown>({
  // NOTE: metaタグの設定
  metaInfo() {
    if (process.env.NODE_ENV === "production") {
      return {};
    }
    return {
      meta: [
        {
          name: "robots",
          content: "none",
        },
      ],
    };
  },
  data() {
    return {
      scrollY: 0,
      previousTheme: null,
    };
  },
  created() {
    window.addEventListener("scroll", this.scroll);
  },
  mounted() {
    // ライトモード固定: 現在のテーマを保存してからライトモードに強制
    this.previousTheme = document.documentElement.getAttribute("data-app-theme");
    document.documentElement.setAttribute("data-app-theme", "light");
  },
  destroyed() {
    window.removeEventListener("scroll", this.scroll);
    // 元のテーマに戻す（nullの場合はデフォルトのlightを設定）
    document.documentElement.setAttribute("data-app-theme", this.previousTheme || "light");
  },
  computed: {
    help() {
      return process.env.VUE_APP_NOTION_HELP!;
    },
  },
  methods: {
    scroll() {
      this.scrollY = window.scrollY;
    },
  },
});
